export default "__VITE_ASSET__0a2c5eed__"